import { v4 as uuidv4 } from 'uuid';
import initializeMediaClient from 'scaleflow/utils/aws-clients/s3MediaClient';

export default async function imageUploadHandler(
  idToken: string,
  orgId: string,
  file: File,
): Promise<string> {
  const id = uuidv4();
  const key = `${id}-${file.name}`;

  // Get the ID token from the current user's session
  if (!idToken) {
    throw new Error('No valid session available for S3 upload');
  }

  // Initialize the S3 client with credentials
  const s3Client = await initializeMediaClient(idToken, orgId);

  // Upload the file and get a signed URL
  const signedUrl = await s3Client.uploadAndGetUrl(
    key,
    file,
    file.type || 'application/octet-stream',
  );
  return signedUrl;
}
